import React, { useState, useRef, useEffect } from "react";
import "./ToolExport.css";

const DxfIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="12" y1="18" x2="12" y2="12" />
    <polyline points="9 15 12 18 15 15" />
  </svg>
);

const PdfIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
  </svg>
);

const ShareIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="18" cy="5" r="3" />
    <circle cx="6" cy="12" r="3" />
    <circle cx="18" cy="19" r="3" />
    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
    <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
  </svg>
);

const ToolExport = ({ onExportDxf, onExportPdf, onShare }) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleDxf = () => {
    if (typeof onExportDxf === 'function') onExportDxf();
  };

  const handlePdf = () => {
    if (typeof onExportPdf === 'function') onExportPdf();
    else alert('PDF dışa aktarma yakında geliyor.');
  };

  const handleShare = () => {
    if (typeof onShare === 'function') onShare();
    else alert('Paylaş özelliği yakında geliyor.');
  };

  return (
    <div className={`toolExport ${isOpen ? "open" : "closed"}`} ref={wrapperRef}>
      {isOpen && (
        <div className="toolExport-left">
          <div className="toolExport-row">
            <button className="toolExport-btn" onClick={handleDxf} title="DXF Dışa Aktar">
              <DxfIcon />
              <span>DXF</span>
            </button>
            <button className="toolExport-btn" onClick={handlePdf} title="PDF Dışa Aktar">
              <PdfIcon />
              <span>PDF</span>
            </button>
            <button className="toolExport-btn" onClick={handleShare} title="Paylaş">
              <ShareIcon />
              <span>Paylaş</span>
            </button>
          </div>
        </div>
      )}
      <div className="toolExport-toggle">
        <button
          className="toolButton toggleArrowButton"
          onClick={() => setIsOpen((prev) => !prev)}
        >
          {isOpen ? "◀" : "Export▶"}
        </button>
      </div>
    </div>
  );
};

export default ToolExport;
